<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
</style>

<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;position:relative;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="flex-shrink:0;height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5" style="align-items:center;flex-wrap:wrap;gap:8px;">
        <div class="flex-wrap" style="white-space:nowrap;align-items:center;">
          平台
          <Select v-model="platform" style="margin-left:5px;width:120px;" @on-change="onFilterChange">
            <Option v-for="p in platforms" :key="p.key" :value="p.key">{{ p.name }}</Option>
          </Select>
        </div>
        <Select v-model="project_id" filterable clearable style="width:320px" placeholder="选择项目" @on-change="onFilterChange">
          <OptionGroup v-for="g in groupedProjects" :key="g.key" :label="g.name">
            <Option v-for="p in g.projects" :key="p.id" :value="p.id">{{ p.name }}</Option>
          </OptionGroup>
        </Select>
        <DatePicker type="date" v-model="started_at" placeholder="起始日期（默认本月起始）" style="width:180px;" />
        <DatePicker type="date" v-model="finished_at" placeholder="截止日期" style="width:160px;" />
      </div>
      <div class="flex-wrap flex-right" style="gap:8px;">
        <Button class="zzl-view-top-refresh" type="default" @click="getProjects">刷新列表</Button>
        <Button @click="copySourceText" :disabled="!aiText">复制日志文本</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;border-top:1px solid var(--border);">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="loading" fix size="large">
          <div class="zzl-view-data-loading-text">抓取日志中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">日志数据</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" size="small" icon="md-download" :loading="loading" :disabled="!project_id" @click="getDayRecordsData">抓取日志</Button>
              <span style="font-size:12px;color:var(--subtext2);">共 {{ recordsCount }} 条</span>
              <span style="font-size:12px;color:var(--subtext2);">字数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="10"
              style="width:100%;flex:1;min-height:0;"
              placeholder="点击“抓取日志”后，按日期拼接后的日志会显示在这里"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              :mod="promptMod"
              :textarea-rows="5"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告生成</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 5" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result ? '重新生成' : '生成报告') }}
            </Button>
            <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
            <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';

export default {
  components: {AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_zzl_dayrecords',
      pageStateFields: ['platform', 'project_id', 'started_at', 'finished_at', 'userText'],
      platform: 'pmis',
      project_id: '',
      started_at: '',
      finished_at: '',
      projects: [],
      loading: false,
      aiText: '',
      userText: '',
      recordsCount: 0,
      ai_executings: false,
      result: '',
    };
  },
  computed: {
    platforms() {
      return [
        {key: 'pmis', name: '项管'},
        {key: 'jlis', name: '监理'},
        {key: 'jgis', name: '监管'},
      ];
    },
    groupedProjects() {
      const groupmap = {};
      this.projects
        .filter((p) => p.platform && p.platform.split(',').includes(this.platform))
        .forEach((p) => {
          const group = p.group || '未分组';
          if (!groupmap[group]) {
            groupmap[group] = [];
          }
          groupmap[group].push(p);
        });
      return Object.keys(groupmap).map((g) => ({
        key: g,
        name: g,
        projects: groupmap[g],
      }));
    },
    promptMod() {
      return `zzl-dayrecords-${this.platform || 'pmis'}`;
    },
    queryStartedAt() {
      if (this.started_at && moment(this.started_at).isValid()) {
        return moment(this.started_at).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      return moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
    },
    queryFinishedAt() {
      if (this.finished_at && moment(this.finished_at).isValid()) {
        return moment(this.finished_at).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      }
      return moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    },
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.getProjects();
    });
  },
  methods: {
    onFilterChange() {
      this.ensureProjectInCurrentPlatform();
    },
    ensureProjectInCurrentPlatform() {
      if (!this.project_id) {
        const first = this.groupedProjects[0] && this.groupedProjects[0].projects[0];
        this.project_id = first ? first.id : '';
        return;
      }
      const exists = this.groupedProjects.some((g) => g.projects.some((p) => p.id === this.project_id));
      if (!exists) {
        const first = this.groupedProjects[0] && this.groupedProjects[0].projects[0];
        this.project_id = first ? first.id : '';
      }
    },
    getProjects() {
      this.$api.get('logined_zzl/projects?q=all').then((res) => {
        this.projects = res.data.data || [];
        this.__initPageState();
        this.ensureProjectInCurrentPlatform();
      });
    },
    buildSourceText(list) {
      return (list || [])
        .map((item) => {
          const date = moment(item.inputDate || item.date || '').format('YYYY-MM-DD HH:mm:ss');
          const content = item.content || '';
          return `=== ${date} ${item.editor_name}===\n${content}`.trim();
        })
        .filter(Boolean)
        .join('\n\n');
    },
    getDayRecordsData() {
      if (!this.project_id) {
        this.Warning('请先选择项目');
        return;
      }
      this.loading = true;
      const query = `pid=${encodeURIComponent(this.project_id)}&started_at=${encodeURIComponent(this.queryStartedAt)}&finished_at=${encodeURIComponent(this.queryFinishedAt)}&platform=${encodeURIComponent(this.platform)}`;
      this.$api.get(`logined_zzl/old_day_records_data?${query}`).then((res) => {
        const rows = (res.data && res.data.data) || [];
        this.recordsCount = rows.length;
        this.aiText = this.buildSourceText(rows);
        const project = this.projects.find((p) => p.id === this.project_id);
        const projectName = project ? project.name : '';
        this.userText = `请基于以下日志数据生成项目工作报告，内容客观、结构清晰、不要虚构信息。\n项目：${projectName}\n平台：${this.platform}\n时间范围：${moment(this.queryStartedAt).format('YYYY/MM/DD')} - ${moment(this.queryFinishedAt).format('YYYY/MM/DD')}\n\n以下是日志数据：`;
      }).catch((e) => {
        this.Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    async copySourceText() {
      if (!this.aiText) {
        return;
      }
      try {
        await navigator.clipboard.writeText(this.aiText);
        this.Success('已复制日志文本');
      } catch (e) {
        this.Error('复制失败');
      }
    },
    zzlReportPdfStem() {
      const project = this.projects.find((p) => p.id === this.project_id);
      const name = project ? project.name.replace(/[/\\?%*:|"<>]/g, '_') : 'dayrecords';
      return `${name}_${this.platform}_dayrecords_${moment().format('YYYYMMDD')}`;
    },
    __afterRestorePageState() {
      if (!this.platform) {
        this.platform = 'pmis';
      }
      if (!this.started_at) {
        this.started_at = moment().startOf('month').format('YYYY-MM-DD');
      }
      if (!this.finished_at) {
        this.finished_at = moment().format('YYYY-MM-DD');
      }
    },
  },
};
</script>
